
  import {spacing, typography} from 'material-ui/styles';

  const styles = {
    logo: {
      cursor: 'pointer',
      fontSize: 22,
      color: 'white',
      lineHeight: `${spacing.desktopKeylineIncrement}px`,
      fontWeight: typography.fontWeightLight,
      backgroundColor: '#02ABCA',
      paddingLeft: 40,
      height: 56,
    },
    menuItem: {
      color: '#666',
      fontSize: 14
    }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/containers/layout/styles/leftDrawerStyles.js